if (!customElements.get('toggle-slider')) {
  class ToggleSlider extends HTMLElement {
    constructor() {
      super();
      this.currentToggle = null;
    }
    
    connectedCallback() {
      this.currentToggle = this.querySelector('[data-action="toggle-images"]:checked')?.value ?? this.querySelector('[data-action="toggle-images"]')?.value;
      if (!this.currentToggle) return;
      
      this.addEventListener('change', e => {
        const toggle = e.target.value;
        const gender = e.target.dataset.genderTarget;
        if (!toggle || !e.target.closest('[data-action="toggle-images"]')) return;
        this.currentToggle = toggle;
        this.toggleImages(this.currentToggle, gender);
      });
      

      const default_selected_radio = this.querySelector('input[type="radio"]:checked');
      
      if (default_selected_radio.dataset.genderTarget) {
        this.querySelectorAll(`[data-gender-value]`).forEach((el) => {
          if (el.dataset.genderValue == default_selected_radio.dataset.genderTarget) {
            el.classList.remove('hidden');
            return;
          }
          el.classList.add('hidden');
        })
      }
    }
    
    toggleImages(toggle, gender) {
      if (!toggle) return;
      if (gender ) {
        document.querySelectorAll(`[data-gender-value]`).forEach((el) => {     
          if (el.dataset.genderValue == gender) {
            el.classList.remove('hidden');
            return;
          }
          el.classList.add('hidden');
        });
        document.querySelectorAll(`[data-gender-target=${gender}]`).forEach((el) => {el.click()})
      } else {
        this.querySelectorAll('[data-toggle-value]').forEach((el) => {     
          if (el.dataset.toggleValue === toggle) {
            el.classList.remove('hidden');
            return;
          }
          
          el.classList.add('hidden');
        });
      }
      
      
      setTimeout(() => { this.querySelector('swiper-carousel')?.slider?.update(); }, 10)
    }
  }
  
  customElements.define('toggle-slider', ToggleSlider);
}